import { defaultConfig, getCurrentEnv } from "./appConstants";
import { NetworkHelper } from "./network";


let config = null;
// export const fetchPropertyConfig = (() => {
  
    export const fetchPropertyConfig = async (property) => {
        console.log(config,'config')
      if (config) {
        return config[property];
      }
  
      try {
        const response = await fetch(`${getCurrentEnv()}/oauth_fe_config/property-config?ver=1.1`);
        if (!response.ok) {
          throw new Error('Failed to fetch config');
        }
  
        config = await response.json();
        return config[property];
      } catch (error) {
        console.error(error);
        return defaultConfig[property];
      }
    };
//   })();